/**
 * config.ts — where the API is (P1 US-113).
 *
 * One value, read from a Vite env var so each environment's build points at its own API, with a
 * documented local default. `import.meta.env` is statically replaced at build time, so the value
 * is baked into the bundle rather than looked up at runtime.
 */

/**
 * The API origin.
 *
 * `VITE_API_BASE_URL` is set per environment:
 *   - local dev   — unset; falls back to the `wrangler dev` default below
 *   - staging     — `https://api-staging.<zone>`
 *   - production  — `https://api.<zone>`
 *
 * The local default is 8787 because that is what `wrangler dev` listens on, and `apps/api`'s
 * `wrangler.toml` allows `http://localhost:5173` and `:4173` through CORS — the `vite dev` and
 * `vite preview` origins — so the pair works with no further configuration on a fresh checkout.
 */
export const API_BASE_URL: string = import.meta.env.VITE_API_BASE_URL ?? 'http://localhost:8787';

/**
 * How long to wait after the last keystroke before calculating. Milliseconds.
 *
 * The oracle recalculated on every `input` event, which was free because the engine was in the
 * page. It is not free over a network — it is one request per character typed into a field. 250 ms
 * is short enough that the result still feels immediate while typing pauses, and long enough that
 * a whole number typed digit by digit is one request rather than four.
 */
export const CALC_DEBOUNCE_MS = 250;
